<template>
  <div :class="$style.wrapper" @click.capture="onCardClickCapture">
    <div :class="$style.imageBoxWrap">
      <div
        ref="sliderRef"
        :class="[$style.imageBox, itemImages.length > 1 && $style.imageBoxDraggable]"
        @scroll="onSliderScroll"
        @mousedown="onMouseDown"
      >
        <div :class="$style.sliderTrack">
          <img
            v-for="(img, idx) in itemImages"
            :key="idx"
            :src="img"
            :alt="item.title"
            :class="$style.sliderImg"
            draggable="false"
            @dragstart.prevent
          />
        </div>
      </div>
      <div v-if="itemImages.length > 1" :class="$style.dots">
        <span
          v-for="(_, idx) in itemImages"
          :key="idx"
          :class="[$style.dot, { [$style.dotActive]: currentImageIndex === idx }]"
        />
      </div>
    </div>

    <div :class="$style.tags">
      <span v-if="item.is_new" :class="$style.tagNew">Новое</span>
      <span v-if="item.is_trade" :class="$style.tagTrade">Торг</span>
      <span v-if="item.total_count" :class="$style.tagCount">{{
        pluralizePairs(item.total_count)
      }}</span>
    </div>

    <div :class="$style.title">{{ item.title }}</div>

    <div :class="$style.price">
      {{ Number(item.min_price).toLocaleString("ru-RU") }} ₽
    </div>
  </div>
</template>

<script>
import { pluralizePairs } from "@/utils/pluralize"

export default {
  name: "Card",
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      currentImageIndex: 0,
      drag: { active: false, startX: 0, startScroll: 0 },
      justDragged: false,
    }
  },
  computed: {
    itemImages() {
      const imgs = this.item?.images
      if (Array.isArray(imgs) && imgs.length) return imgs
      if (this.item?.preview_image) return [this.item.preview_image]
      return []
    },
  },
  methods: {
    pluralizePairs,
    onSliderScroll() {
      this.updateDotIndex()
    },
    updateDotIndex() {
      const el = this.$refs.sliderRef
      if (!el || this.itemImages.length <= 1) return
      const scrollLeft = el.scrollLeft
      const width = el.clientWidth
      const index = Math.round(scrollLeft / width)
      if (index !== this.currentImageIndex && index >= 0 && index < this.itemImages.length) {
        this.currentImageIndex = index
      }
    },
    onMouseDown(e) {
      if (this.itemImages.length <= 1) return
      const el = this.$refs.sliderRef
      if (!el) return
      this.drag = { active: true, startX: e.pageX, startScroll: el.scrollLeft }
      document.addEventListener("mousemove", this.onMouseMove)
      document.addEventListener("mouseup", this.onMouseUp)
      document.body.style.userSelect = "none"
      document.body.style.cursor = "grabbing"
    },
    onMouseMove(e) {
      if (!this.drag.active) return
      const el = this.$refs.sliderRef
      if (!el) return
      const dx = this.drag.startX - e.pageX
      el.scrollLeft = this.drag.startScroll + dx
    },
    onMouseUp() {
      const el = this.$refs.sliderRef
      if (this.drag.active && el && Math.abs(el.scrollLeft - this.drag.startScroll) > 5) {
        this.justDragged = true
      }
      this.drag.active = false
      document.removeEventListener("mousemove", this.onMouseMove)
      document.removeEventListener("mouseup", this.onMouseUp)
      document.body.style.userSelect = ""
      document.body.style.cursor = ""
    },
    onCardClickCapture(e) {
      if (this.justDragged) {
        this.justDragged = false
        e.stopPropagation()
      }
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  position: relative;
}

.imageBoxWrap {
  position: relative;
  width: 8.75rem;
  height: 8.75rem;
  margin: 0 auto 0.5rem auto;
}

.imageBox {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.imageBoxDraggable {
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
}

.sliderTrack {
  display: flex;
  height: 100%;
  width: max-content;
}

.sliderImg {
  width: 8.75rem;
  min-width: 8.75rem;
  height: 8.75rem;
  object-fit: contain;
  transform: scale(-1, 1);
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.dots {
  position: absolute;
  bottom: 0.25rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 0.25rem;
  pointer-events: none;
  z-index: 1;
}

.dot {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.2);
  transition: background 0.2s;
}

.dotActive {
  background: rgba(0, 0, 0, 0.6);
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
}

.tagNew {
  background: #ec66081a;
  color: #ec6608;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.tagTrade {
  background: #0000000d;
  color: #00000040;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.tagCount {
  background: #0000000d;
  color: #00000040;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.title {
  max-width: 90%;
  font-size: 0.875rem;
  margin-bottom: 0.625rem;
  line-height: 1.25;
}

.price {
  font-size: 1rem;
  font-weight: 600;
}
</style>
